import SubdomainSite from "@/subdomains/SubdomainSite";
import config from "@/subdomains/configs/realty";

/** Realty page — realty.bizlem.com */
export default function RealtyPage() {
  return <SubdomainSite config={config} />;
}

export { config };
